import api from './api';

export interface ProductTypeClassification {
  _id: string;
  productId: string;
  productType: string;
  createdAt: string;
  updatedAt: string;
}

export const productTypes = [
  'بلوزة',
  'بنطلون',
  'لاب كوت',
  'تيشيرت',
  'جاكيت',
  'طقم',
  'كاب طبي'
];

// جلب أنواع المنتجات المتاحة
export const getProductTypes = async (): Promise<string[]> => {
  const response = await api.get('/product-types/types');
  return response.data.data;
};

// تعيين نوع لمنتج
export const setProductType = async (
  productId: string,
  productType: string
): Promise<ProductTypeClassification> => {
  const response = await api.post('/product-types', {
    productId,
    productType
  });
  return response.data.data;
};

// جلب نوع منتج معين
export const getProductType = async (
  productId: string
): Promise<ProductTypeClassification | null> => {
  const response = await api.get(`/product-types/${productId}`);
  return response.data.data;
};

// جلب جميع المنتجات مع أنواعها (المصنفة فقط)
export const getAllProductTypes = async (
  productType?: string,
  page: number = 1,
  limit: number = 50
) => {
  const params = new URLSearchParams();
  if (productType) params.append('productType', productType);
  params.append('page', page.toString());
  params.append('limit', limit.toString());

  const response = await api.get(`/product-types?${params.toString()}`);
  return response.data;
};

// جلب جميع المنتجات مع أنواعها (محددة وغير محددة)
export const getAllProductsWithTypes = async (
  search?: string,
  page: number = 1,
  limit: number = 50
) => {
  const params = new URLSearchParams();
  if (search) params.append('search', search);
  params.append('page', page.toString());
  params.append('limit', limit.toString());

  const response = await api.get(`/product-types/all-products?${params.toString()}`);
  return response.data;
};

// حذف نوع منتج
export const deleteProductType = async (productId: string) => {
  const response = await api.delete(`/product-types/${productId}`);
  return response.data;
};

// تحميل قالب Excel لأنواع المنتجات
export const downloadProductTypesTemplate = async () => {
  const response = await api.get('/product-types/download-template', {
    responseType: 'blob'
  });
  
  // إنشاء رابط للتحميل
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'product-types-template.xlsx');
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// استيراد أنواع المنتجات من Excel
export const importProductTypes = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/product-types/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  
  return response.data;
};
